import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getPriceList = createAsyncThunk("/thunk/getlist-price-list", async () => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-price-list`);
    return response;
  } catch (error) {
    throw error;
  }
});